import { Edit } from '@mui/icons-material';
import { Card, CardContent, CardHeader, IconButton } from '@mui/material';
import { FC, useCallback } from 'react';
import {
  Datagrid,
  FieldProps,
  List,
  Link,
  Loading,
  TextField,
  useShowController,
  useRecordContext,
} from 'react-admin';
import { useNavigate } from 'react-router-dom';

export const ExtensionField = (props: FieldProps) => {
  const value = useRecordContext(props);
  const { extension } = value;
  if (String(extension) === 'pdf') {
    return <span>Инструкция</span>;
  }
  return <span>Характеристики</span>;
};

export const LinkFileEditField = (props: FieldProps) => {
  const value = useRecordContext(props);
  const { id } = value;
  console.log(id);
  let link = '/files/' + String(id);
  return <Link to={link}>Редактировать</Link>;
};

export const CategoryShow: FC = () => {
  const data = useShowController();
  const navigate = useNavigate();
  const { record: { id } = {}, isLoading, isFetching } = data;

  const filter = { category_id: `${id}` };

  const handleClickEdit = useCallback(() => {
    navigate(`/categories/${id}`);
  }, [id, navigate]);

  if (isLoading || isFetching) {
    return <Loading />;
  }
  return (
    <Card>
      <CardHeader
        title={`${data.record.name}`}
        subheader={data.record.article}
        action={
          <IconButton assistantaria-label="Edit" onClick={handleClickEdit}>
            <Edit />
          </IconButton>
        }
      />
      <CardContent>
        <b>Артикуль: </b>
        {data.record.id}
        <br />
        <b>Имя: </b>
        {data.record.name}
        <br />
        <br />
        <br />
        <span>Список продуктов:</span>
        <List
          emptyWhileLoading
          resource="products"
          exporter={false}
          filter={filter}
        >
          <Datagrid>
            <TextField source="id" />
            <TextField source="article" label="Артикуль" />
            <TextField source="name" label="Имя" />
          </Datagrid>
        </List>
      </CardContent>
    </Card>
  );
};
